"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PencilIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.142.837a1 1 0 00-1.414 0l-.707.707 2.121 2.122.707-.708a1 1 0 000-1.414l-.707-.707zm-2.828 1.414l2.121 2.122-8.485 8.485-2.381 1.19a.694.694 0 01-.931-.93l1.19-2.381 8.486-8.486z"
  })))
});
PencilIcon.displayName = 'PencilIcon';
var _default = exports.default = PencilIcon;